export const MODAL_ON = 'open modal'
export function openModal(action, data) {
  return {
    type: MODAL_ON,
    payload: action,
    data: data
  }
}

export const MODAL_OFF = 'close modal'
export function closeModal(action) {
  return {
    type: MODAL_OFF,
  }
}


export const MENU_TOOGLE=  'menu toogle'
export function menuToogle(toogle) {
  return {
    type: MENU_TOOGLE,
    toogle: toogle
  }
}



// WEBPACK FOOTER //
// ./src/model/System/actions.js